module.exports = __webpack_public_path__ + "src/assets/img/eng-hot.6fe30241.svg";